export default {
    primary: '#05092299'
}